import { FC } from 'react';
import { Avatar, Text } from '@chakra-ui/react';

import { TeamMemberRole } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';

import locales from './locales';

type TeamMemberRoleCardIdentity = {
  firstName: string;
  lastName: string;
  email: string;
};

type InvitationCostReviewProps =
  | {
      identity?: TeamMemberRoleCardIdentity;
      showDiff?: false;
      role: TeamMemberRole;
    }
  | {
      identity?: TeamMemberRoleCardIdentity;
      currentRole: TeamMemberRole;
      newRole: TeamMemberRole;
      showDiff: true;
    };

export const TeamMemberRoleCard: FC<InvitationCostReviewProps> = (props) => {
  const { identity } = props;
  return (
    <SunshineCard
      alignItems="center"
      title={identity ? `${identity.firstName} ${identity.lastName}` : ''}
    >
      <SunshineCard.Slot name="aside">
        <Avatar
          background="grey.100"
          borderRadius="radius-10"
          boxSize="space-32"
          color="text-primary"
          fontWeight="weight-500"
          name={identity ? `${identity.firstName} ${identity.lastName}` : ''}
        />
      </SunshineCard.Slot>
      {identity ? (
        <SunshineCard.Content>
          <SunshineCard.Text>{identity?.email}</SunshineCard.Text>
        </SunshineCard.Content>
      ) : null}
      <SunshineCard.Slot name="action">
        <Text>
          {props.showDiff ? (
            <>
              {locales.roles[props.currentRole]}{' '}
              <SunshineIcon name="arrow-right" /> {locales.roles[props.newRole]}
            </>
          ) : (
            <>{locales.roles[props.role]}</>
          )}
        </Text>
      </SunshineCard.Slot>
    </SunshineCard>
  );
};
